// extracted by mini-css-extract-plugin
export default {"lista":"Projetos_lista__t4RdY"};